module.exports = __webpack_public_path__ + "img/logo-dark.69a8ae3e.svg";